import { GetRoles } from "./getRoles";
import { DEFAULT_PAGE } from "../../contstants";

// Adapts the paginated bps-go role search response to the { data, count }
// shape consumed by useData / DataTable.
const FilterRoles = async (perPage, filters) => {
  const page = filters.page || DEFAULT_PAGE;
  const name = filters.s || "";
  const status = filters.status;
  const isActive =
    status === "active" ? true : status === "inactive" ? false : "";

  const response = await GetRoles(
    perPage,
    (page - 1) * perPage,
    name,
    isActive
  );

  return {
    data: response.roles || [],
    count: response.total || 0,
  };
};

export default FilterRoles;
